module.exports = __webpack_public_path__ + "img/app.274d47cb.png";